<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-text.pa-6
      div.d-flex.align-center
        v-icon(color="danger500" size="24") $yzi-alert-circle
        div.text-xl.font-medium.neutral700--text.ml-4 Alert: Insufficient credit
      div.text-md.neutral700--text.mt-4 {{ blast.method === 'sms' ? 'SMS' : blast.method === 'email' ? 'Email' : 'WhatsApp' }} deliverance for your
       span.font-semibold.mx-1 {{ offer.name }}
       | offer has been paused because of insufficient credit.
      div.text-md.neutral700--text.mt-2 Delivery for the date(s) listed below can’t be deployed:
      template(v-for="(schedule, index) in tempSchedules")
        yc-checkbox.mt-2.ml-3(v-model="schedule.selected")
          template(v-slot:label)
            div.text-sm.font-semibold.neutral700--text.ml-3 {{ schedule.blasted_at | humanizeDate }}
      div.text-md.neutral700--text.mt-4 This is the cost needed to complete the selected message delivery:
      div.text-xl.font-semibold.neutral700--text.mt-2 {{ totalCost | displayPrice($currency) }}
      div.text-sm.neutral700--text.mt-4 Your balance:
      credit-balance
      div.text-md.neutral700--text.mt-4 You can reload and resend, or you can ignore the remaining messages; meaning that the customers that do not yet receive the message will be excluded from your marketing insights.
        
    v-divider
    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button.mr-2(label="Ignore" size="md" outlined :disabled="disableIgnore" :loading="isLoading" @click="ignoreSchedule")
      y-button(label="Resend" size="md" :disabled="disableResend" :loading="isLoading" @click="resendSchedule")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreditBalance from '@/components/clinic/marketing/CreditBalance.vue'

export default {
  components: { CreditBalance },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    schedules: {
      type: Array,
      default: (() => [])
    },
    blast: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer'
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    tempSchedules: {
      get () {
        return this.schedules 
      },
      set (newValue) {
        this.$emit('update:schedules', newValue)
      }
    },
    totalCost () {
      let cost = 0
      let selected = this.tempSchedules.filter(f => f.selected)
      if (selected.length) {
        cost = selected.map(m => m.metadata.required_credit).reduce((a, b) => a + b, 0)
      }
      return cost
    },
    creditBalance() {
      return this.company.prepaid_credits
    },
    disableIgnore () {
      let disable = true
      if (this.tempSchedules.find(f => f.selected)) disable = false
      return disable
    },
    disableResend () {
      let disable = false
      if (!this.tempSchedules.find(f => f.selected)) disable = true
      if (this.totalCost > this.creditBalance) disable = true
      return disable
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    async ignoreSchedule () {
      this.isLoading = true
      let selected = this.tempSchedules.filter(f => f.selected)
      try {
        for (let schedule in selected) {
          await this.$axios.patch(`/marketing/${this.company.slug}/blasts/${this.blast.id}/schedules/${selected[schedule].id}`, { status: 'ignored' })
            .catch(err => {
              let message = this.$t('error_message.unable_to_complete_request')
              if (err.response.data) {
                if (err.response.data.detail) {
                  message = err.response.data.detail
                } else {
                  let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                  if (data) { message = data }
                }
              }
              throw message
            })
          this.$emit('updated')
          this.closeDialog()
        }
      } catch (err) {
        this.showMessage(['error', err])
      } finally {
        this.isLoading = false
      }
    },
    async resendSchedule () {
      this.isLoading = true
      let selected = this.tempSchedules.filter(f => f.selected)
      try {
        for (let schedule in selected) {
          await this.$axios.post(`/marketing/${this.company.slug}/blasts/${this.blast.id}/resend`, { schedule: selected[schedule].id })
            .catch(err => {
              let message = this.$t('error_message.unable_to_complete_request')
              if (err.response.data) {
                if (err.response.data.detail) {
                  message = err.response.data.detail
                } else {
                  let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                  if (data) { message = data }
                }
              }
              throw message
            })
          this.$emit('updated')
          this.closeDialog()
        }
      } catch (err) {
        this.showMessage(['error', err])
      } finally {
        this.isLoading = false
      }
    },
    closeDialog () {
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
</style>